import React from "react";

import { useDrop } from "src/core/drops/hooks";

import { IProductMaybeWithSubstitution } from "../utils";

export const useProductIsAllowedSubs = (product: IProductMaybeWithSubstitution | null) => {
  const [ { drop } ] = useDrop();

  const allowedSubs = React.useMemo(() => {
    if (product === null) {
      return false;
    } else if (!drop?.groupedSettings.allow_substitutions?.value.allowed) {
      return false;
    } else if (!product?.substitution?.replacementProduct.prices?.length) {
      return false;
    }

    return true;
  }, [ drop?.groupedSettings.allow_substitutions?.value.allowed, product ]);

  return allowedSubs;
};